import React, { useState } from 'react';

function GuidedRemovalDecisionScreen({ serviceName, onDecide, onBack }) {
  // Briefly highlight the picked option before the parent navigates away.
  const [picked, setPicked] = useState(null);

  function handlePick(decision) {
    if (picked) return; // ignore double-tap
    setPicked(decision);
    setTimeout(() => onDecide(decision), 180);
  }

  return (
    <div className="removal-decision-screen">
      <h1 className="removal-decision-title">Do you need removal?</h1>
      {serviceName && <p className="removal-decision-sub">For your {serviceName}</p>}
      <p className="removal-decision-hint">This adds time to your appointment</p>
      <div className="removal-decision-buttons">
        <button
          type="button"
          className={`removal-decision-btn ${picked === 'yes' ? 'picked' : ''}`}
          onClick={() => handlePick('yes')}
          aria-pressed={picked === 'yes'}
        >
          <span className={`guided-card-indicator ${picked === 'yes' ? 'checked' : ''}`} aria-hidden="true">
            {picked === 'yes' && '✓'}
          </span>
          <span className="removal-decision-btn-label">Yes</span>
          <span className="removal-decision-btn-sub">I need removal</span>
        </button>
        <button
          type="button"
          className={`removal-decision-btn ${picked === 'no' ? 'picked' : ''}`}
          onClick={() => handlePick('no')}
          aria-pressed={picked === 'no'}
        >
          <span className={`guided-card-indicator ${picked === 'no' ? 'checked' : ''}`} aria-hidden="true">
            {picked === 'no' && '✓'}
          </span>
          <span className="removal-decision-btn-label">No</span>
          <span className="removal-decision-btn-sub">No removal needed</span>
        </button>
      </div>
      {onBack && (
        <button type="button" className="removal-decision-back" onClick={onBack}>← Back</button>
      )}
    </div>
  );
}

export default GuidedRemovalDecisionScreen;
